
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTwowayAnalogClosed as ObiTwowayAnalogClosedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-twoway-analog-closed.js';
 
 
 

 
 export const ObiTwowayAnalogClosed = createComponent({
   react: React,
   tagName: 'obi-twoway-analog-closed',
   elementClass: ObiTwowayAnalogClosedElement,
   events: {
     
   }
  });
 
 